import React from 'react';

export type LeaderboardRunAliasesContextValue = {
  alias?: string;
  isEditable?: boolean;
  isSaving?: boolean;
  onAliasChange?: (alias: string) => void;
};

export const LeaderboardRunAliasesContext = React.createContext<LeaderboardRunAliasesContextValue>(
  {},
);
